import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onQRScan, onEmergencyContact }) => {
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const navigate = useNavigate();

  const quickActionItems = [
    {
      id: 'qr-scan',
      title: 'Escanear QR',
      description: 'Confirmar recogida de bolsa',
      icon: 'QrCode',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      onClick: () => setIsQRModalOpen(true)
    },
    {
      id: 'nearby',
      title: 'Cerca de mí',
      description: 'Bolsas en tu área',
      icon: 'MapPin',
      color: 'text-success',
      bgColor: 'bg-success/10',
      onClick: () => console.log('Show nearby bags')
    },
    {
      id: 'favorites',
      title: 'Favoritos',
      description: 'Tus negocios preferidos',
      icon: 'Heart',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      onClick: () => console.log('Show favorites')
    },
    {
      id: 'history',
      title: 'Historial',
      description: 'Bolsas rescatadas',
      icon: 'History',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      onClick: () => console.log('Show history')
    }
  ];

  const handleQRScan = () => {
    setIsQRModalOpen(false);
    if (onQRScan) {
      onQRScan();
    }
  };

  return (
    <>
      <div className="bg-card border border-border rounded-lg p-6 mb-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading font-bold text-lg text-foreground">
            Acciones Rápidas
          </h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/impact-tracking')}
            iconName="TrendingUp"
          />
        </div>

        {/* Quick Action Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {quickActionItems?.map((action) => (
            <button
              key={action?.id}
              onClick={action?.onClick}
              className="p-4 rounded-lg border border-border hover:shadow-warm-sm transition-smooth text-left group"
            >
              <div className={`w-10 h-10 rounded-full ${action?.bgColor} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <Icon name={action?.icon} size={20} className={action?.color} />
              </div>
              
              <h3 className="font-body font-medium text-foreground text-sm mb-1">
                {action?.title}
              </h3>
              
              <p className="text-xs text-muted-foreground">
                {action?.description}
              </p>
            </button>
          ))}
        </div>

        {/* Emergency Contact */}
        <div className="mt-4 pt-4 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            onClick={onEmergencyContact}
            iconName="Phone"
            iconPosition="left"
            className="w-full text-error border-error/30 hover:bg-error/10"
          >
            Contacto de Emergencia
          </Button>
        </div>
      </div>
      {/* QR Scanner Modal */}
      {isQRModalOpen && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
          <div className="bg-background rounded-lg p-6 w-full max-w-md">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-semibold text-lg text-foreground">
                Escanear Código QR
              </h3>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setIsQRModalOpen(false)}
              >
                <Icon name="X" size={20} />
              </Button>
            </div>

            {/* QR Scanner Placeholder */}
            <div className="aspect-square bg-muted rounded-lg flex items-center justify-center mb-4 relative overflow-hidden">
              {/* Scanner Frame */}
              <div className="absolute inset-4 border-2 border-primary rounded-lg">
                <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4 border-primary rounded-tl-lg" />
                <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4 border-primary rounded-tr-lg" />
                <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4 border-primary rounded-bl-lg" />
                <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4 border-primary rounded-br-lg" />
              </div>
              
              {/* Scanner Line Animation */}
              <div className="absolute inset-4 overflow-hidden rounded-lg">
                <div className="w-full h-0.5 bg-primary animate-pulse absolute top-1/2 transform -translate-y-1/2" />
              </div>
              
              <div className="text-center z-10">
                <Icon name="QrCode" size={64} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
                <p className="text-muted-foreground text-sm">
                  Coloca el código QR dentro del marco
                </p>
              </div>
            </div>

            <div className="space-y-3">
              <Button
                variant="default"
                className="w-full"
                onClick={handleQRScan}
                iconName="Camera"
                iconPosition="left"
              >
                Activar Cámara
              </Button>
              
              <Button
                variant="outline"
                className="w-full"
                onClick={() => setIsQRModalOpen(false)}
              >
                Cancelar
              </Button>
            </div>

            <div className="mt-4 p-3 bg-muted rounded-md">
              <div className="flex items-start space-x-2">
                <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5" />
                <div>
                  <p className="text-xs text-muted-foreground">
                    Escanea el código QR proporcionado por el negocio para confirmar la recogida de tu bolsa sorpresa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuickActions;